import useSWR from 'swr'
import { getUserIntercomHash } from '../../legacy-api/user/api'
import { ApiConfig } from '../../shared/apiConfig'
import { buildCacheKey } from '../../shared/utils/cache'
import { createHash } from '../../shared/utils/createHash'
import { Region } from '../../shared/utils/region'
import { getMe } from './api'

const getMeAndIntercomHash = async (config: ApiConfig) => {
  if (!config.accessToken) return null
  const [user, intercomHash] = await Promise.all([
    getMe({ token: config.accessToken }, config),
    getUserIntercomHash(config)
  ])
  return { ...user, intercomUserHash: intercomHash }
}

// Hook is conventionally used outside of HermesSdkProvider, so we need to pass accessToken and tenant as params
export const useYourUserData = (params: { accessToken: string; tenant: Region }) => {
  const cacheKey = buildCacheKey('useYourUserData', {
    token: createHash(params?.accessToken)
  })
  const {
    data,
    isLoading,
    error,
    mutate: refresh
  } = useSWR(cacheKey, () => getMeAndIntercomHash({ accessToken: params?.accessToken, tenant: params?.tenant }), {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  })

  return {
    data,
    isLoading,
    error,
    refresh
  }
}
